var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2017 4.81738H15.7982V13.0766H11.2017V4.81738Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4936 8.94658C11.4936 7.26847 12.2815 5.78006 13.4927 4.81697C12.6026 4.11654 11.479 3.69336 10.2532 3.69336C7.34936 3.69336 5 6.04272 5 8.94658C5 11.8504 7.34936 14.1998 10.2532 14.1998C11.479 14.1998 12.6026 13.7766 13.4927 13.0762C12.2815 12.1277 11.4936 10.6247 11.4936 8.94658Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.94658C22 11.8504 19.6507 14.1998 16.7468 14.1998C15.5211 14.1998 14.3975 13.7766 13.5073 13.0762C14.7331 12.1131 15.5065 10.6247 15.5065 8.94658C15.5065 7.26847 14.7185 5.78006 13.5073 4.81697C14.3975 4.11654 15.5211 3.69336 16.7468 3.69336C19.6507 3.69336 22 6.05731 22 8.94658Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 17,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.71e68d5957d20014bba6394bd5d37614.svg";
export { ForwardRef as ReactComponent };